import { GenericTestRouteState } from './generic-test-state'

export const BasicHealthTestRouteState = GenericTestRouteState.named(
  'BasicHealthTestRouteState'
)
